import {
  getFacet,
  getText,
  appendGOATandCountryCodeToTitle,
  sortAndSliceList,
  constructList,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getSubcategoryMetadata';

export const getSubcategoryMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  pathname,
}) => {
  // Pulling out static strings for translation purposes
  const pathnameSplit = pathname?.split('/');
  const isSneakers = pathnameSplit?.[1] === 'sneakers';
  const { facets = [] } = constructorResponse?.response || {};
  const brandFacet = getFacet(facets, 'brand');
  const subCategoryString: string = startCase(pathnameSplit?.[2]);
  const topThreeBrandsAndMore = sortAndSliceList(brandFacet?.options, 4);

  const { constructedListWithStartCase } = constructList({
    list: topThreeBrandsAndMore,
    key: 'display_name',
  });

  constructedListWithStartCase[constructedListWithStartCase.length - 1] = 'more';

  const title = isSneakers
    ? t(`${TP}.titleSneaker`, 'Buy {subCategoryString}: New Releases & Iconic Styles', {
        subCategoryString,
      })
    : t(`${TP}.title`, 'Buy {subCategoryString}: Streetwear & Luxury', { subCategoryString });
  const description = t(
    `${TP}.description`,
    'Shop {subCategoryString} on GOAT. Featuring new releases and iconic styles from {constructedListWithStartCase}. Buyer protection guaranteed on all purchases.',
    {
      subCategoryString: subCategoryString.toLowerCase(),
      constructedListWithStartCase: getText('', constructedListWithStartCase),
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
